import { brandPrimaryHover, kitTintColor, noteTintColor, success } from '../../../../web/styles/colors';
import { DefaultBorder, truncateTextStyle } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	company: {
		...truncateTextStyle,
		':hover': {
			textDecoration: 'underline',
		},
		color: brandPrimaryHover,
		cursor: 'pointer',
		fontSize: 18,
		fontWeight: 600,
		textDecoration: 'none',
		width: 400,
	},
	container: {
		':last-child': {
			borderBottom: DefaultBorder,
		},
		alignItems: 'center',
		borderTop: DefaultBorder,
		display: 'flex',
		justifyContent: 'space-between',
		padding: '20px 0',
	},
	csm: {
		fontSize: 14,
		width: 300,
	},
	green: {
		color: success,
	},
	orange: {
		color: kitTintColor,
	},
	red: {
		color: '#F70000',
	},
	status: {
		fontSize: 14,
		width: 300,
	},
	statusColor: {
		marginRight: 6,
		textTransform: 'capitalize',
	},
	yellow: {
		color: noteTintColor,
	},
});
